import React from "react";

import { Colors, Spinner } from "@zapier/design-system";

import { PAYPAL_BUTTON_ID } from "../constants";

const buttonCss = {
  alignItems: "center",
  background: "#ffc439",
  borderRadius: 3,
  color: Colors.white,
  display: "flex",
  height: 44,
  justifyContent: "center",
  position: "relative",
  minWidth: 250,
} as const;

type Props = {
  /** show loading indicator */
  isLoading: boolean;
};

const PaypalButtonPlaceholder = (props: Props) => {
  return (
    <div css={buttonCss} id={PAYPAL_BUTTON_ID}>
      {props.isLoading && <Spinner />}
    </div>
  );
};

export default PaypalButtonPlaceholder;
